import { List } from "@mantine/core";
import { generatePath, Link, useParams } from "react-router";
import { TABS as ENERGY_DATA_TABS } from "../../../../../components/EnergyData/EnergyDataView/EnergyDataView";
import { ROUTES } from "../../../../../routes";
import type { Paragraph6CreditErrorMessageDetailProps } from "../Paragraph6CreditErrorMessage";

function EnergyErrors({
  paragraph6CreditErrors
}: Paragraph6CreditErrorMessageDetailProps) {
  const { projectId } = useParams<{ projectId: string }>();
  const energyErrors = paragraph6CreditErrors.filter(
    (error) => error.energy_data_check_failed
  );

  if (!(energyErrors.length > 0)) {
    return null;
  }

  const energyDataUploadPath = projectId
    ? generatePath(
        `${ROUTES.energyData.entry}/${ENERGY_DATA_TABS.TAB_ENERGY_DATA_UPLOAD}`,
        { projectId }
      )
    : undefined;

  return (
    <List.Item>
      {energyDataUploadPath ? (
        <Link to={energyDataUploadPath}>Energiedaten</Link>
      ) : (
        <strong>Energiedaten</strong>
      )}{" "}
      im Zeitraum:{" "}
      {energyErrors
        ?.map(
          (energyError) =>
            `${energyError.billing_period.start_date} bis ${energyError.billing_period.end_date}`
        )
        .join(", ")}
    </List.Item>
  );
}

export { EnergyErrors };
